export function formatPickerAccessibleName(action: string, identifier: string) {
  return `${action}: ${identifier}`;
}
